import assumptionsTypeRouterHooks from './assumptionsTypeRouterHooks'
import generalRouterHook from './generalRouterHook'
export default (router) => {
  assumptionsTypeRouterHooks(router)
  generalRouterHook(router)
}